import React from 'react';
import Button from '../../components/Button';
import NextStepsCard from '../../components/NextStepsCard';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { markOnbording } from '../../core/actions';
import './next-steps.scss';

const NextSteps: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    function onSubmitted() {
        dispatch(markOnbording());
        navigate('/tired-no-reason', { replace: true });
    }
    return (
        <div className="next-steps">
            <h1 className="next-steps__title">Rest assured, you're in the right place.</h1>
            <h4 className="next-steps__subtitle">Our team is dedicated to providing care that is not only thoughtful but also effective, addressing your needs with both understanding and expertise.</h4>
            <NextStepsCard />
            <Button type='primary' onPressed={onSubmitted}>{'Next'}</Button>
        </div>
    );
}

export default NextSteps;
